import { createContext } from "react";
import useProjectSummaries from "../hooks/data/useLotStatusCountsByProjectId";

export interface IProjectSummariesContext extends ReturnType<typeof useProjectSummaries> {

};

const ProjectSummariesContext = createContext<IProjectSummariesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default ProjectSummariesContext